import { getIn } from 'final-form';
export var getFirstErrorField = function getFirstErrorField(inputs, errors) {
  // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
  var htmlInputs = inputs;
  return htmlInputs.find(function (input) {
    // If input is hidden, do not focus
    if (input.type === 'hidden') {
      return false;
    }

    // If input ID matches the error, focus
    if (input.id && getIn(errors, input.id)) {
      return true;
    }

    // Default to base behavior
    return input.name && getIn(errors, input.name);
  });
};